// This import loads the firebase namespace along with all its type information.
import firebase from 'firebase/app';
// These imports load individual services into the firebase namespace.
import 'firebase/firestore';
import {CLUE_LATLON} from "./constants/Clue";

export const METERS_TO_MILES = .000621;
export const DEGREES_TO_RADIANS = Math.PI/180;
export const METERS_PER_DEGREE_LAT = 111320;

export function spaceBeforeNewLine(string) {
    if (!string) return null;

    return string.replace(/\\n/g, " \n");
}

export function stripNewLines(string) {
    if (!string) return null;

    return string.replace(/\\n/g, " ");
}

export function lowerCaseReplaceSpaces(string) {
    if (!string) return null;

    return string.toLowerCase().replace(/ /g, "_");
}

export function googleLatLngToFirebaseGeopoint(latLng) {

    return new firebase.firestore.GeoPoint(latLng.lat(), latLng.lng());
}

export function googleBoundsToFirebaseBounds(bounds) {
    const southLat = bounds.getSouthWest().lat();
    const northLat = bounds.getNorthEast().lat();
    const westLon = bounds.getSouthWest().lng();
    const eastLon = bounds.getNorthEast().lng();

    return {
        // Putting new Geopoint() is considered invalid by firestore. :-(
        southwest: new firebase.firestore.GeoPoint(southLat, westLon),
        northeast: new firebase.firestore.GeoPoint(northLat, eastLon)
    };
}

export function firebaseBoundsToGoogle(bounds, google) {
   if (bounds == null) {
        return null;
    }
    const {southwest, northeast} = bounds;

    return new google.maps.LatLngBounds(
        new google.maps.LatLng(southwest.latitude, southwest.longitude),
        new google.maps.LatLng(northeast.latitude, northeast.longitude)
    );
}

/** Return a LatLngBounds representing most of the western world */
export function northAmerica(google) {
    return new google.maps.LatLngBounds(
        new google.maps.LatLng(30, -110),
        new google.maps.LatLng(48, -75));
}

/**
 *  Bounds should be a google.maps.LatLngBounds object
 *  The "mapDim" parameter value should be an object with "height" and "width"
 */
export function zoomFromBounds(bounds, mapDim, forShowingClues = false) {
    const WORLD_DIM = { height: 256, width: 256 };
    const ZOOM_MAX = 21;
    const ZOOM_MIN = 3;

    function latRad(lat) {
        const sin = Math.sin(lat * DEGREES_TO_RADIANS);
        const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        // return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        return Math.log(mapPx / worldPx / fraction) / Math.LN2;
    }

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    const lngDiff = ne.lng() - sw.lng();
    const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    const latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    const lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

   return Math.max(Math.min(latZoom, lngZoom, ZOOM_MAX), ZOOM_MIN);
}

export function estimatedHuntDistance(gameBounds, clues) {
    let totalMetersMin = 0;
    let totalMetersMax = 0;

    if (!gameBounds || !clues) return "Error, no game or clues";

    if (clues.length < 1) return "Approx. 0.0 miles";

    const gameCenter = getBoundsCenter(gameBounds);

    let previousLatLon = gameCenter;
    // distance to first clue
    totalMetersMax += distanceMeters(gameBounds.southwest, gameBounds.northeast)/2.0;

    const latLon0 = clues[0][CLUE_LATLON];
    if (!! latLon0) {
        totalMetersMax += distanceMeters(gameCenter, clues[0][CLUE_LATLON])*1.3;
        previousLatLon = latLon0;
    }

    for (let i=1; i < clues.length; i++) {
        const currentLatLon = clues[i][CLUE_LATLON];
        if (!currentLatLon) continue;

        const baseDistance = distanceMeters(previousLatLon, currentLatLon);
        totalMetersMin += baseDistance*1.1;
        totalMetersMax += baseDistance*1.3;
        previousLatLon = currentLatLon;
    }

    const milesMin = totalMetersMin * METERS_TO_MILES;
    const milesMax = totalMetersMax * METERS_TO_MILES;

    return milesMin.toFixed(1) + " to " + milesMax.toFixed(1) + " miles";
}

export function distanceMeters(geoPoint1, geoPoint2) {
    const latDiff = geoPoint1.latitude - geoPoint2.latitude;
    const aveLat = (geoPoint1.latitude + geoPoint2.latitude)/2.0;
    const lonAdjustment = Math.cos(aveLat*Math.PI/180);
    const lonDiff = (geoPoint1.longitude - geoPoint2.longitude)*lonAdjustment;

    const hypotDist = Math.sqrt( latDiff*latDiff + lonDiff*lonDiff );
    return hypotDist * METERS_PER_DEGREE_LAT;
}

function getBoundsCenter(firebaseBounds) {
    const sw = firebaseBounds.southwest;
    const ne = firebaseBounds.northeast;
    const lat = (sw.latitude + ne.latitude) / 2.0;
    const lon = (sw.longitude + ne.longitude) / 2.0;
    return new firebase.firestore.GeoPoint(lat, lon);
}



// WEBPACK FOOTER //
// ./src/helper_functions.js